<template>

  <div class="container" style="max-width:50rem;">
    <div class="panel panel-default">

      <div class="panel-heading">
        <h2 style="margin:0">Reset Password</h2>
      </div>

      <form name="resetPasswordForm" id="resetPasswordForm">
     
        <div class="panel-body">
          <div class="container" style="width: inherit;">
            
            <div class="thumbnail" style="border: 0">
              <img :src="lockImage" alt="lock"/>
              <div class="caption" style="text-align: center">
                <h3>Lost your password?</h3>
                <p>Let's try to reset it.</p>
              </div>
            </div>
            
            <div class="form-group">
              <div>
                <label for="username">Username</label>
                <input type="text" class="form-control" id="username" placeholder="Username" name="username" v-model="username" required>
              </div>
            </div>

            <div class="alert alert-success" role="alert" v-if="requestSubmitted">
              <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
              <span class="sr-only"></span> An email with instructions has been sent to {{email}}.
            </div>

            <div class="alert alert-danger" role="alert" v-if="error">
              <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span class="sr-only">Error:</span> {{error}}
            </div>
          </div>
        </div>

        <div class="panel-footer">
          <div style="text-align: center">
            <button type="submit" class="btn btn-primary" style="width: 50%;" :disabled="!username||requestSubmitted" @click.prevent="requestReset">Reset My Password</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  
</template>

<script setup>

import {ref} from 'vue';
import { useUserStore } from '@/stores/user.store'
import lockImage from '@/assets/icons8-lock-50.png'

const requestSubmitted = ref(false);
const error = ref('');
const username = ref('');
const email = ref('');
const store = useUserStore();

async function requestReset(){

  requestSubmitted.value = false;
  error.value = '';
  
  try{
    email.value = await store.requestPasswordReset(username.value);
    requestSubmitted.value = true;
  }
  catch (e){
    console.error(e)
    error.value = e;
    if (e.response?.data?.message){
      error.value = e.response.data.message;
    }
  }
}

</script>

<style scoped>

</style>